import React, { useState } from 'react';
import css from './LandingLocationSelect.css';
import { useIntl } from 'react-intl';

export const LandingLocationSelect = (props) => {
  // second elem in arr necessary ? - weasel
  const [continentList, setContinentList] = useState([
    'africa',
    'asia',
    'europe',
    'southamerica',
    'worldwide',
  ]);

  const intl = useIntl();
  return (
    <form onChange={props.handleChange}>
      <select
        style={{
          paddingRight: '40px',
          fontFamily: 'Poppins, Helvetica, Arial, sans-serif',
          fontSize: '16px',
          lineHeight: '30px',
          paddingLeft: '10px'

        }}
        className={css.continentselect}
        onChange={props.onChange}
        value={props.value}
      >
        {continentList.map((n, id) => {
          //console.log('this id is: ' + id);
          return <option key={id} value={n}>{intl.formatMessage({ id: n })}</option>;
        })}
      </select>
    </form>
  );

  // add seo comp here - weasel
};
export default LandingLocationSelect;
